import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/product/productIndex",
  name: "productIndex",
  component: function component() {
    return import("../../../views/productIndex/productIndex.vue");
  },
  meta: {
    title: "产品中心",
    foot: false
  }
}];